<ion-header [ngClass]="from == navPageName.GoAppHomeComponent ? 'new-home-header' : ''">
    <ind-page-title [viewData]="activitiesDetailsPanePageTitle" (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
    <business-process *ngIf="meetingProcessView && meetingProcessView.length >= 4" [viewData]="meetingProcessView" [scroller]="scroller"></business-process>
</ion-header>
<ion-content #scroller [novaMeetingContext]="novaMeetingActivity">
    @if (isActivityTypeSupported()) {
        <ion-list id="{{detailsSectionId}}" class="form-list">
            <ind-section-header id="details" [viewData]='detailsSectionHeaderViewData'></ind-section-header>
            @for (formField of firstLevelFormFields; track trackByFormField($index, formField)) {
                <ind-form-field [viewData]="formField"></ind-form-field>
            }
            <ion-row>
                <ion-col size="6">
                    @if (meetingStartDateField && !meetingStartDateField.isHidden) {
                        <ind-datetime-form [viewData]="meetingStartDateField" (onUpdate)="onTimeUpdated()"></ind-datetime-form>
                    }
                </ion-col>
                <ion-col size="6">
                    @if (meetingStartTimeField && !meetingStartTimeField.isHidden) {
                        <ind-datetime-form [viewData]="meetingStartTimeField" (onUpdate)="onTimeUpdated()"></ind-datetime-form>
                    }
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6">
                    @if (meetingEndDateField && !meetingEndDateField.isHidden) {
                        <ind-datetime-form [viewData]="meetingEndDateField" (onUpdate)="onTimeUpdated()"></ind-datetime-form>
                    }
                </ion-col>
                <ion-col size="6">
                    @if (meetingEndTimeField && !meetingEndTimeField.isHidden && !meetingEndDateField.isHidden) {
                        <ind-datetime-form [viewData]="meetingEndTimeField" (onUpdate)="onTimeUpdated()"></ind-datetime-form>
                    }
                </ion-col>
            </ion-row>
            @if (meetingDurationField) {
                <ion-row>
                    <ion-col size="12">
                        <ind-form-field [viewData]="meetingDurationField" (onUpdate)="onTimeUpdated()"></ind-form-field>
                    </ion-col>
                </ion-row>
            }

            @if (displayConflictMsg) {
                <activity-conflict-alert-msg [msg]="conflictMsg"></activity-conflict-alert-msg>
            }

            <!-- Checkin status  -->
            <ion-row>
              <ion-col size="6">
                  @if (checkInField && !isAccountVisitNestedMeeting && !this.disableGPSCheckInFlowForHCPMeeting) {
                      <ind-form-field [viewData]="checkInField"></ind-form-field>
                  }
              </ion-col>
              <ion-col size="6">
                @if (checkOutField && !isAccountVisitNestedMeeting && !this.disableGPSCheckInFlowForHCPMeeting) {
                    <ind-form-field [viewData]="checkOutField"></ind-form-field>
                }
              </ion-col>
          </ion-row>

            <!-- Best Time Recommendations -->
            @if (authService.user.showBestTimeRecommendation && showTimeRecommendations && !device.isOffline && !(isAccountVisitRecord || isAccountVisitNestedMeeting)) {
              @if (this.isTimeRecommendationEnabled && recommendedByCurrentTime.length > 0) {
                <ion-row>
                  <ion-col size="12">
                    <div class="dv-item-label">
                      <span class="span-recommendations-header"> {{'RECOMMENDATIONS' | translate}} </span>
                      <span class="span-recommendations-close" (click)="closeRecommendedations()">
                        <img src="assets/imgs/closeGeneeScreen.svg" width="25" height="25">
                      </span>
                    </div>
                  </ion-col>
                </ion-row>
              }
              @for (slot1 of recommendedByCurrentTime; track trackByTimeSlot($index, slot1)) {
                <ion-col size="2">
                  <div class="dv-item">
                    <div>{{ slot1[0].substring(0, 3) }}:</div>
                  </div>
                </ion-col>
                <ion-col size="10">
                  <div class="dv-item">
                    @for (slot2 of slot1[1]; track trackByTimeSlotItem($index, slot2)) {
                      <button class="btn-Timeslot" (click)="setRecommendedDateTime(slot2)">
                        {{ slot2['timeSlot'] }}
                      </button>
                    }
                  </div>
                </ion-col>
              }
            }
            @if (hasCoachingPlan) {
                <ind-form-field [viewData]="coachingPlanField"></ind-form-field>
            }
            @if (shouldShowMeetingTypeField()) {
                <ind-form-field [viewData]="meetingTypeFormField"></ind-form-field>
            }
            <ind-form-field [viewData]="ownerFormField"></ind-form-field>
            @if (activityTypeFormField) {
                <ind-form-field [viewData]="activityTypeFormField" (handleAdditionalControls)="openCaptureSignature($event)"></ind-form-field>
            }
            @if (activityTypeFormField) {
                <ind-form-field [viewData]="activitySubTypeFormField"></ind-form-field>
            }
            <ind-form-field [viewData]="accountFormField"  (handleAdditionalControls)="openAccounts($event)"></ind-form-field>
            <ind-form-field [viewData]="contactFormField" [nearMePillsLoader]="nearMePillsLoader" [sharedLocationPillsLoader]="sharedLocationPillsLoader" (handleAdditionalControls)="openContacts($event)"></ind-form-field>
            <ind-form-field [viewData]="locationField"></ind-form-field>
            <ind-form-field [viewData]="meetinglinkedtoamarketingbusinessplanField"></ind-form-field>
            <ind-form-field [viewData]="marketingBusinessPlanField"></ind-form-field>
            @if (presentationDurationFormField) {
                <ind-form-field [viewData]="presentationDurationFormField"></ind-form-field>
            }
            @if (shouldShowMeetingURL()) {
                <ion-item class="meeting-url-item" (click)="openURLPopover($event)">
                    <ion-label class='form-field-header-label'>
                        <p class='form-field-label-text'>
                            @if (!features.liveMeet) {
                                <ion-text>{{'ACTIVITY_DETAILS_LIVE_TIME' | translate}}</ion-text>
                            }
                            @if (features.liveMeet) {
                                <ion-text>{{'LIVE_MEETING' | translate}}</ion-text>
                            }
                        </p>
                        <p class='form-field-value'>
                          <ion-text>{{meetingURL?.substring((meetingURL?.length - 4), meetingURL?.length)}}</ion-text>
                        </p>
                    </ion-label>
                    <div class="copy-link" (click)="onLiveMeetingLinkCopyClick($event)">
                      <ion-icon id="activity-detail-05" slot="end" tappable class="copy-icon" src="{{ nativeShareAvailable ? 'assets/imgs/share_social_icon.svg' : 'assets/imgs/link.svg' }}" width="20"></ion-icon>
                    </div>
                  </ion-item>
            }
            @if (teamsLink) {
                <ion-item class="meeting-url-item" (click)="openTeamsURLPopover($event)">
                  <ion-label class='form-field-header-label'>
                      <p class='form-field-label-text'><ion-text>{{'ACTIVITY_DETAILS_LIVE_TIME' | translate}}</ion-text></p>
                      <p class='form-field-value'><ion-text>{{teamsLink?.substring(0, 42)}}</ion-text></p>
                  </ion-label>
                  <ion-icon id="activity-detail-05" slot="end" tappable class="copy-icon" src="assets/imgs/link.svg" (click)="onTeamsLinkCopy($event)" width="20"></ion-icon>
              </ion-item>
            }

            @for (formField of secondLevelFormFields; track trackByFormField($index, formField)) {
                <ind-form-field [viewData]="formField"></ind-form-field>
            }

            <!-- appConfigFields for Appointment -->
            @for (appConfigField of appointmentConfigFields; track trackByAppConfigField($index, appConfigField)) {
                <ind-form-field [viewData]="getAppontmentsFormField(appConfigField)"></ind-form-field>
            }
            @if (shouldShowGPSCheckin()) {
                <ion-row>
                  <ion-col>
                    <ind-form-field [viewData]="appealStatusFormField"></ind-form-field>
                  </ion-col>
                </ion-row>
            }

            <!-- appConfigFields based on format details-->
            @for (appConfigField of appointmentConfigFields; track trackByAppConfigField($index, appConfigField)) {
              <ind-form-field [viewData]="getAppontmentsFormField(appConfigField, true)"></ind-form-field>
          }
        </ion-list>
        <!-- InStore Meeting Photos-->
        @if (isInStoreMeeting) {
          <div id="{{photosSectionId}}">
            <ind-section-header [viewData]="photosSectionHeader"
              (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div class="image-wrapper" [ngClass]="{'events-container':!activityService.selectedActivity['inStorePhotos']?.length}"
              lines="none">
              @for (photo of activityService.selectedActivity['inStorePhotos']; track trackByPhoto($index, photo)) {
                <div class="image-container" (click)="openPhotoViewer(photo)">
                  <img class="thumbnail" [id]="photo.indskr_photoattachmentid" io-thumbnail [src]="photo.indskr_photourl" loading="lazy">
                  <img tappable class="delete-icon" src="assets/imgs/delete_black.svg" width="24" loading="lazy"
                  [ngClass]="{'disabled': device.isOffline
                                      || backgroundUploadInProgress
                                      || activityService.selectedActivity.isCompleted
                                      || activityService.selectedActivity.ownerId != this.authService.user.xSystemUserID}"
                    (click)="deletePhotoAttachments($event, photo)" />
                </div>
              }
            </div>
          </div>
        }

        @if (shouldShowGPSCheckin()) {          
          <div id="{{gpsActivityPhotosSectionId}}">
            <ind-section-header [viewData]="gpsActivityPhotosSectionHeader"
              (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div class="photo-container">
              <div class="table">
                <ion-row>
                  <ion-col size="6">
                    <div class="table-header">
                      <div class="col">{{'CHECK_IN_PHOTOS' | translate}}</div>
                    </div>
                    @for (pt of checkInPhotoAttachments; track trackByPhotoAttachment($index, pt)) {
                      <div class="table-row">
                        <div class="col photo-card" (click)="openPhotoViewerForGPSActivity(pt, GPSActivity.CHECKIN)">
                          <img class="thumbnail" io-thumbnail [src]="pt.photos[0].indskr_photourl" loading="lazy" />
                          @if (pt.photos.length > 1) {
                              <div class="count-badge"> {{pt.photos.length}}</div>
                          }
                        </div>
                      </div>
                    }
                  </ion-col>
                  <ion-col size="6" class="verticalSeparationLine">
                    <div class="table-header">
                      <div class="col">{{'CHECK_OUT_PHOTOS' | translate}}</div>
                    </div>
                    @for (pt of checkOutPhotoAttachments; track trackByPhotoAttachment($index, pt)) {
                      <div class="table-row">
                        <div class="col photo-card" (click)="openPhotoViewerForGPSActivity(pt, GPSActivity.CHECKOUT)">
                          <img class="thumbnail" io-thumbnail [src]="pt.photos[0].indskr_photourl" loading="lazy" />
                          @if (pt.photos.length > 1) {
                              <div class="count-badge"> {{pt.photos.length}}</div>
                          }
                        </div>
                      </div>
                    }
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </div>
        }

        @if (features.isMeetingObjectiveSelectionEnabled) {
          <div id="{{objectiveSectionId}}">
            <ind-section-header [viewData]="objectiveSectionHeader"
              (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div [ngClass]="{'events-container':!activityService.selectedActivity['activityObjectives']?.length}" lines="none">
              @for (objective of activityService.selectedActivity['activityObjectives']; track trackByObjective($index, objective)) {
                <ion-item>
                  <ion-label text-wrap>{{ objective.indskr_name}}</ion-label>
                </ion-item>
              }
            </div>
          </div>
        }
        <!-- ═══ SAMPLES & MATERIALS SECTION (unified: Drops / Request / Materials) ═══ -->
        <!-- The whole section hides only when ALL THREE tabs are hidden for the
             selected format. Materials is Promotional Material — a real feature
             (not a stub) reusing the same allocation-tab-bar/inline-allocation-order
             machinery as Drops, scoped to isPromoMaterial allocations. -->
        @if ((features.sampleDropEnabled && isSampleDropSectionVisible) || (features.sampleDeliveryRequestEnabled && isSdrSectionVisible) || (features.promoMaterialEnabled && isPromoMaterialSectionVisible)) {
          <div id="{{samplesMaterialsSectionId}}">
            <ind-section-header
                [viewData]="samplesMaterialsSectionHeader">
            </ind-section-header>

            <!-- A tab bar only makes sense with a choice to make — when the format
                 leaves exactly one of Drops/Request/Materials visible, show its
                 name as a plain title instead of a single-option button row. -->
            @if (visibleSamplesMaterialsTabsCount > 1) {
              <div class="samples-materials-subtabs">
                @if (features.sampleDropEnabled && isSampleDropSectionVisible) {
                  <button class="samples-materials-subtab-btn"
                      [class.samples-materials-subtab-btn--active]="activeSamplesMaterialsSubTab === 'drops'"
                      (click)="onSamplesMaterialsSubTabChange('drops')">
                    <span class="subtab-label">{{ 'SAMPLES' | translate }}</span>
                    <span *ngIf="activeSampleDropsInMeeting?.length > 0" class="tab-badge">{{ activeSampleDropsInMeeting.length }}</span>
                  </button>
                }
                @if (features.promoMaterialEnabled && isPromoMaterialSectionVisible) {
                  <button class="samples-materials-subtab-btn"
                      [class.samples-materials-subtab-btn--active]="activeSamplesMaterialsSubTab === 'materials'"
                      (click)="onSamplesMaterialsSubTabChange('materials')">
                    <span class="subtab-label">{{ 'MATERIALS' | translate }}</span>
                    <span *ngIf="activePromoMaterialsInMeeting?.length > 0" class="tab-badge">{{ activePromoMaterialsInMeeting.length }}</span>
                  </button>
                }
                @if (features.sampleDeliveryRequestEnabled && isSdrSectionVisible) {
                  <button class="samples-materials-subtab-btn"
                      [class.samples-materials-subtab-btn--active]="activeSamplesMaterialsSubTab === 'request'"
                      (click)="onSamplesMaterialsSubTabChange('request')">
                    <span class="subtab-label">{{ 'REQUESTS' | translate }}</span>
                    <span *ngIf="activeSdrsInMeeting?.length > 0" class="tab-badge">{{ activeSdrsInMeeting.length }}</span>
                  </button>
                }
              </div>
            }

            <!-- DROPS tab body — unchanged Sample Drop markup, now gated on the sub-tab instead of its own section.
                 Also gated on isSampleDropSectionVisible: activeSamplesMaterialsSubTab can still be stale as
                 'drops' right after a format change hides it (its own button is gone, but the active-tab
                 state doesn't reset itself), which rendered the body with nothing to select it. -->
            @if (activeSamplesMaterialsSubTab === 'drops' && isSampleDropSectionVisible) {
              <ion-list class="sample-drop-section">

                  <!-- Allocation Tabs -->
                  @if (activeSampleDropsInMeeting?.length > 0 || isCreatingAllocation || (!activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive)) {
                      <div class="allocation-tab-bar">
                          @for (alloc of activeSampleDropsInMeeting; track alloc.ID) {
                              <button class="alloc-tab-btn"
                                      [class.alloc-tab-btn--active]="selectedAllocationId === alloc.ID"
                                      [disabled]="scrappingAllocationId === alloc.ID"
                                      (click)="onAllocationTabChange(alloc.ID)">
                                  <span class="tab-dot"
                                        [class.tab-dot--completed]="alloc.state === 1"
                                        [class.tab-dot--open]="alloc.state !== 1">
                                  </span>
                                  <span class="tab-label">{{ alloc.orderId || ('ALLOCATION_ORDER' | translate) }}</span>
                                  @if (scrappingAllocationId !== alloc.ID && alloc.state !== 1 && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive) {
                                    <ion-icon name="closebutton"
                                         class="alloc-tab-scrap-icon"
                                         (click)="onAllocationScrapFromTab($event, alloc)">
                                    </ion-icon>
                                  }
                              </button>
                          }
                          @if (isCreatingAllocation) {
                              <div class="alloc-tab-btn alloc-tab-btn--skeleton">
                                  <span class="tab-dot tab-dot--skeleton"></span>
                                  <span class="tab-label tab-label--skeleton"></span>
                              </div>
                          }
                          <!-- "+ New" replaces the old section-header "+" control — lives inline in the
                               tab row it creates into (see reference design). Hidden while a create is
                               already in flight (skeleton above covers that state). -->
                          @if (!isCreatingAllocation && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive) {
                              <button class="alloc-tab-btn alloc-tab-btn--add"
                                      [disabled]="isSingleAoMeeting && activeSampleDropsInMeeting.length >= 1"
                                      (click)="createNewInlineAllocation(false)">
                                  <!-- Plain glyph, not <ion-icon>: this component has a global
                                       `ion-icon { font-size: 2.8rem !important; }` rule that blew this
                                       chip's height up to match the icon instead of the pill. -->
                                  <span class="alloc-tab-add-icon">+</span>
                                  <span class="tab-label">{{ 'NEW' | translate }}</span>
                              </button>
                          }
                      </div>

                      <!-- Active Allocation Detail -->
                      @for (alloc of activeSampleDropsInMeeting; track alloc.ID) {
                          @if (selectedAllocationId === alloc.ID) {
                              <div class="allocation-detail-wrap">
                                  <inline-allocation-order
                                      [allocation]="alloc"
                                      [isReadOnly]="activityService.selectedActivity?.isCompleted || activityService.selectedActivity?.state === meetingState.Canceled || enableReadonlyViewForMeetings || activityService.teamViewActive"
                                      [isScrapping]="scrappingAllocationId === alloc.ID"
                                      [meetingId]="activityService.selectedActivity?.ID"
                                      [meetingContacts]="meetingContactsRef"
                                      [isPromoMaterial]="alloc.isPromoMaterial"
                                      (onSaved)="onAllocationSaved($event)"
                                      (onScrapped)="onAllocationScrapped($event)"
                                      (onCompleted)="onAllocationCompleted($event)"
                                      (onRequestSelectContact)="openContactsForAllocation()"
                                      (onContactSelected)="onAllocationContactSelected($event)">
                                  </inline-allocation-order>
                              </div>
                          }
                      }
                  }

                  @if (!activeSampleDropsInMeeting?.length && !isCreatingAllocation) {
                    <div class="sdr-section-placeholder ion-text-center ion-padding">
                      {{ 'NO_SAMPLE_DROPS_YET' | translate }}
                    </div>
                  }
              </ion-list>
            }

            <!-- MATERIALS tab body — Promotional Material. Same allocation-tab-bar/
                 detail machinery as Drops, scoped to isPromoMaterial allocations
                 and always creating via createNewInlineAllocation(true). Not
                 subject to the single-AO Sample Drop cap. -->
            @if (activeSamplesMaterialsSubTab === 'materials' && isPromoMaterialSectionVisible) {
              <ion-list class="sample-drop-section">

                  <!-- Allocation Tabs -->
                  @if (activePromoMaterialsInMeeting?.length > 0 || isCreatingAllocation || (!activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive)) {
                      <div class="allocation-tab-bar">
                          @for (alloc of activePromoMaterialsInMeeting; track alloc.ID) {
                              <button class="alloc-tab-btn"
                                      [class.alloc-tab-btn--active]="selectedAllocationId === alloc.ID"
                                      [disabled]="scrappingAllocationId === alloc.ID"
                                      (click)="onAllocationTabChange(alloc.ID)">
                                  <span class="tab-dot"
                                        [class.tab-dot--completed]="alloc.state === 1"
                                        [class.tab-dot--open]="alloc.state !== 1">
                                  </span>
                                  <span class="tab-label">{{ alloc.orderId || ('PROMOTIONAL_MATERIAL' | translate) }}</span>
                                  @if (scrappingAllocationId !== alloc.ID && alloc.state !== 1 && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive) {
                                    <ion-icon name="closebutton"
                                         class="alloc-tab-scrap-icon"
                                         (click)="onAllocationScrapFromTab($event, alloc)">
                                    </ion-icon>
                                  }
                              </button>
                          }
                          @if (isCreatingAllocation) {
                              <div class="alloc-tab-btn alloc-tab-btn--skeleton">
                                  <span class="tab-dot tab-dot--skeleton"></span>
                                  <span class="tab-label tab-label--skeleton"></span>
                              </div>
                          }
                          @if (!isCreatingAllocation && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive) {
                              <button class="alloc-tab-btn alloc-tab-btn--add"
                                      (click)="createNewInlineAllocation(true)">
                                  <span class="alloc-tab-add-icon">+</span>
                                  <span class="tab-label">{{ 'NEW' | translate }}</span>
                              </button>
                          }
                      </div>

                      <!-- Active Allocation Detail -->
                      @for (alloc of activePromoMaterialsInMeeting; track alloc.ID) {
                          @if (selectedAllocationId === alloc.ID) {
                              <div class="allocation-detail-wrap">
                                  <inline-allocation-order
                                      [allocation]="alloc"
                                      [isReadOnly]="activityService.selectedActivity?.isCompleted || activityService.selectedActivity?.state === meetingState.Canceled || enableReadonlyViewForMeetings || activityService.teamViewActive"
                                      [isScrapping]="scrappingAllocationId === alloc.ID"
                                      [meetingId]="activityService.selectedActivity?.ID"
                                      [meetingContacts]="meetingContactsRef"
                                      [isPromoMaterial]="alloc.isPromoMaterial"
                                      (onSaved)="onAllocationSaved($event)"
                                      (onScrapped)="onAllocationScrapped($event)"
                                      (onCompleted)="onAllocationCompleted($event)"
                                      (onRequestSelectContact)="openContactsForAllocation()"
                                      (onContactSelected)="onAllocationContactSelected($event)">
                                  </inline-allocation-order>
                              </div>
                          }
                      }
                  }

                  @if (!activePromoMaterialsInMeeting?.length && !isCreatingAllocation) {
                    <div class="sdr-section-placeholder ion-text-center ion-padding">
                      {{ 'NO_PROMOTIONAL_MATERIAL_YET' | translate }}
                    </div>
                  }
              </ion-list>
            }

            <!-- REQUEST tab body — Sample Delivery Requests raised from this meeting.
                 Mirrors the Drops tab chrome (pill row + "+ New" + inline editor).
                 Atomic-submit: a new SDR is an editable draft until Submit, then a
                 read-only row. (OMNI-61002)
                 Also gated on isSdrSectionVisible — same stale-active-tab issue as Drops:
                 a format change hiding Request removes its button but doesn't reset
                 activeSamplesMaterialsSubTab, so the body rendered anyway.
                 features.sampleDeliveryRequestEnabled is required too — isSdrSectionVisible
                 is purely a format-hide check, unrelated to the SDR feature action. Without
                 this, a role without SAMPLE_DELIVERY_REQUESTS mapped could still reach the
                 "+ New" create control whenever resolveDefaultSubTab defaults onto 'request'
                 (e.g. a meeting that already has an SDR from another attendee/co-visitor). -->
            @if (activeSamplesMaterialsSubTab === 'request' && isSdrSectionVisible && features.sampleDeliveryRequestEnabled) {
              <ion-list class="sample-drop-section">
                @if (activeSdrsInMeeting?.length > 0 || isCreatingSdr || (!activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive)) {
                  <div class="allocation-tab-bar">
                      @for (item of activeSdrsInMeeting; track item.id) {
                          <button class="alloc-tab-btn"
                                  [class.alloc-tab-btn--active]="selectedSdrId === item.id"
                                  [disabled]="scrappingSdrId === item.id"
                                  (click)="onSdrTabChange(item.id)">
                              <span class="tab-dot"
                                    [class.tab-dot--pending]="item.pendingSync"
                                    [class.tab-dot--completed]="!item.pendingSync && getSdrStatusColor(item.statusCode) === 'green'"
                                    [class.tab-dot--open]="!item.pendingSync && getSdrStatusColor(item.statusCode) === 'blue'"></span>
                              <span class="tab-label">{{ sdrPillLabel(item) }}</span>
                              <!-- Scrap (cancel) icon — Draft (Active) only, mirrors Sample Drop's
                                   own close icon exactly (state!==1/completed guard there ==
                                   statusCode===sdrStatusActive here: a Submitted-or-later SDR is
                                   the "completed order" equivalent and not scrappable). -->
                              @if (item.statusCode === sdrStatusActive && scrappingSdrId !== item.id && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive) {
                                <ion-icon name="closebutton"
                                     class="alloc-tab-scrap-icon"
                                     (click)="onSdrScrapFromTab($event, item)">
                                </ion-icon>
                              }
                          </button>
                      }
                      <!-- Mirrors Sample Drop's alloc-tab-btn--skeleton: shown only while
                           createNewInlineSdr's create-on-New call is actually in flight. -->
                      @if (isCreatingSdr) {
                          <div class="alloc-tab-btn alloc-tab-btn--skeleton">
                              <span class="tab-dot tab-dot--skeleton"></span>
                              <span class="tab-label tab-label--skeleton"></span>
                          </div>
                      }
                      <!-- Hidden while creating (skeleton above covers that instant) — mirrors
                           Sample Drop's own "+New" exactly. Re-enabled once the draft exists,
                           same as Drop's; further edits on that draft are gated separately by
                           activeInlineSdr?.isBusy below, not by isCreatingSdr. -->
                      @if (!isCreatingSdr && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity?.state !== meetingState.Canceled && !enableReadonlyViewForMeetings && !activityService.teamViewActive) {
                          <button class="alloc-tab-btn alloc-tab-btn--add"
                                  [disabled]="activeInlineSdr?.isBusy ?? false"
                                  (click)="createNewInlineSdr()">
                              <span class="alloc-tab-add-icon">+</span>
                              <span class="tab-label">{{ 'NEW' | translate }}</span>
                          </button>
                      }
                  </div>

                  <!-- Selected saved SDR: editable when Active (Draft, resumable), read-only
                       otherwise. A freshly-created Draft (via createNewInlineSdr) flows through
                       here too, once it's in activeSdrsInMeeting and selectedSdrId — same as any
                       other resumable Active SDR, not a special "new" case. -->
                  @for (item of activeSdrsInMeeting; track item.id) {
                      @if (selectedSdrId === item.id) {
                          <div class="allocation-detail-wrap">
                              <inline-sample-delivery-request
                                  [sdr]="item.statusCode === sdrStatusActive ? (resumingSdr ?? item) : item"
                                  [isReadOnly]="item.statusCode !== sdrStatusActive || activityService.selectedActivity?.isCompleted || activityService.selectedActivity?.state === meetingState.Canceled || enableReadonlyViewForMeetings || activityService.teamViewActive"
                                  [meetingId]="activityService.selectedActivity?.ID"
                                  [meetingContacts]="meetingContactsRef"
                                  [meetingStart]="activityService.selectedActivity?.scheduledStart"
                                  [meetingEnd]="activityService.selectedActivity?.scheduledEnd"
                                  (onSaved)="onSdrSaved($event)"
                                  (onContactSelected)="onSdrContactSelected($event)">
                              </inline-sample-delivery-request>
                          </div>
                      }
                  }
                }

                @if (!activeSdrsInMeeting?.length && !isCreatingSdr) {
                  <div class="sdr-section-placeholder ion-text-center ion-padding">
                    {{ 'NO_SAMPLE_DELIVERY_REQUESTS_YET' | translate }}
                  </div>
                }
              </ion-list>
            }

            <!-- MATERIALS tab body — intentionally empty; stub tab above is disabled so this never renders yet. -->
          </div>
        }
        @if (!hideMeetingStructure) {
          <meeting-structure id="{{meetingStSectionId}}" (openNewActivityPage)="openNewActivityPage()" [meetingStructureAccessedFrom]="'ActivitiesDetailsPanePage'" [backgroundUploadInProgress]="backgroundUploadInProgress"></meeting-structure>
        }
        @if (sharedResources && sharedResources?.length > 0) {
            <shared-resources id="{{sharedResourcesSectionId}}" [isReadOnlyJointMeeting]="isReadOnlyJointMeeting" [activity]="activityService.selectedActivity">
            </shared-resources>
        }
        @if (isProcedureSectionEnabled) {
          <div id="{{procedureSectionId}}">
            <ind-section-header [viewData]="proceduresSectionHeader"
              (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div [ngClass]="{'events-container':!(activityService.selectedActivity['activityProcedures']?.length)}" lines="none">
              @for (procedure of activityService.selectedActivity['activityProcedures']; track trackByProcedure($index, procedure)) {
                <ion-item>
                  <ion-label text-wrap>{{ procedure.name }}</ion-label>
                </ion-item>
              }
            </div>
          </div>
        }
        @if (features.keyMessageSelectionEnabled && !authService.user.buConfigs?.indskr_disableproductsection) {
            <product-key-messages-v2
              id="{{keyMessagesSectionId}}"
              [isReadOnlyJointMeeting]="isReadOnlyJointMeeting"
              [backgroundUploadInProgress]="backgroundUploadInProgress"
              [isProductRequired]="requiredFields['product-key-messages']['isRequired'] && isNotReadOnly"
              (openKeyMessageSentiment)="openKeyMessageSentimentPage($event)">
            </product-key-messages-v2>
        }

        <!-- Supporting Materials -->
        @if (isSupportingMaterialsEnabled) {
          <div id="{{supportingMaterialsSectionId}}">
            <ind-section-header [viewData]="supportingMaterialsSectionHeader"
              (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div [ngClass]="{'events-container':!(activityService.selectedActivity['activitySupportingMaterials']?.length)}" lines="none">
              @for (material of activityService.selectedActivity['activitySupportingMaterials']; track trackByMaterial($index, material)) {
                <ion-item>
                  <ion-label text-wrap>{{ material.name }}</ion-label>
                </ion-item>
              }
            </div>
          </div>
        }
        <!-- Product Indications -->
        @if (features.productIndicationEnabled && productIndicationSectionViewData) {
            <reorder-items-list id="{{productIndicationSectionId}}" [ngClass]="{'notesemptysection':!features.productIndicationEnabled}" [viewData]="productIndicationSectionViewData" [selectedData]="selectedProductIndications" (saveItems)="onProductIndicationsSave($event)"></reorder-items-list>
        }

        <!-- Therapeutic Areas -->
        @if (features.therapeuticAreaEnabled) {
            <therapeutic-area-list id="{{therapeuticSectionId}}" [ngClass]="{'notesemptysection':!features.therapeuticAreaEnabled}" (saveTA)="onSaveTA($event)" [therapeuticAreas]="therapeuticAreas" [isReadOnlyJointMeeting]="isReadOnlyJointMeeting"
                [backgroundUploadInProgress]="backgroundUploadInProgress" [isTARequired]="requiredFields['therapeutic-area']['isRequired'] && isNotReadOnly"></therapeutic-area-list>
        }

        <!-- Disease Areas -->
        @if (features.diseaseAreaEnabled && diseaseAreaSectionViewData) {
            <reorder-items-list id="{{diseaseAreaSectionId}}" [ngClass]="{'notesemptysection':!features.diseaseAreaEnabled}" [viewData]="diseaseAreaSectionViewData" [selectedData]="selectedDiseaseAreas" (saveItems)="onDiseaseAreasSave($event)"></reorder-items-list>
        }

        @if (hasMeetingEventsFA) {
          <ion-list>
            <ind-section-header id="{{meetingEventsSectionId}}" [viewData]="eventsSectionHeader"
                                (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div [ngClass]="{'events-container':!this.applicableEvents.length}" lines="none">
              @for (event of applicableEvents; track trackByEvent($index, event)) {
                <ion-item>
                  <ion-label text-wrap>{{ event.name}}</ion-label>
                </ion-item>
              }
            </div>
          </ion-list>
        }
        @if (isOppSectionEnabled) {
          <ion-list>
            <ind-section-header id="{{meetingOpportunitiesSectionId}}" [viewData]="opportunitiesSectionTitle"
              (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div [ngClass]="{'opportunities-container':!this.applicableOpportunities.length}" lines="none">
              @for (opportunities of applicableOpportunities; track trackByOpportunity($index, opportunities)) {
                <ion-item>
                  <ion-label (click)="selctedOpport(opportunities)" text-wrap>{{ opportunities.opportunityName ? opportunities.opportunityName : '' }}</ion-label>
                  @if (features.openOpportunityDynamic) {
                    <button ion-button clear icon-start [disabled] ="activityService.selectedActivity.ownerId != authService.user.systemUserID" (click)="opportunityService.openOpportunityDynamicLink(opportunities)" style="background-color: transparent;">
                      <img class="popupImage" src="assets/imgs/popup-link-icon.png" alt="Link Icon" loading="lazy">
                    </button>
                  }
                </ion-item>
              }
            </div>
          </ion-list>
        }
        @if (isMeetingAssetsEnabled) {
          <ion-list>
            <ind-section-header id="{{meetingAssetsSectionId}}" [viewData]="assetsSectionTitle" (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
            <div [ngClass]="{'opportunities-container':!applicableAssetsModel.length}" lines="none">
              @for (item of applicableAssetsModel; track trackByAsset($index, item)) {
                <main-card [viewData]='item'></main-card>
                <ind-hierarchy-list-item [hidden]="!item.isExpanded" [viewData]="item.childItems"></ind-hierarchy-list-item>
              }
            </div>
          </ion-list>
        }
        @if (features.notesEnabled) {
            <ion-list>
                <ind-section-header id="{{meetingNotesSectionId}}" [viewData]="notesSectionHeader" (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
                @if (isNotesReadOnly()) {
                    <ion-item class="notesemptysection" lines="none">
                      @if (activityService.selectedActivity?.isCompleted || activityService.teamViewActive || backgroundUploadInProgress || activityService.selectedActivity?.isDiffPosition ||  this.activityService.selectedActivity.state == 2) {
                          <ind-text-area id="activity-detail-notes-attach"
                                         [readonly]="true" [maxLength]="1000"
                                         [showAttachment]="isAttachmentAdded" [attachmentTitle]="attachmentTitle" (removeAttachment)="removeAttachment($event)" (downloadNotesAttachment)="downloadAttachment($event)"
                                         [(value)]="activityService.selectedActivity.notes" (indFocus)="onNotesFocus()" (indBlur)="saveNotes()" [rows]="4" [cols]="10">
                          </ind-text-area>
                      }
                    </ion-item>
                }
                @if (!isNotesReadOnly()) {
                    <ind-text-area id="activity-detail-11" [placeHolder]="notesPlaceholder" [disabled]="isNotesDisabled()" [maxLength]="1000"
                       [showAttachment]="isAttachmentAdded" [attachmentTitle]="attachmentTitle" (removeAttachment)="removeAttachment($event)" (downloadNotesAttachment)="downloadAttachment($event)"
                        [(value)]="activityService.selectedActivity.notes" (indFocus)="onNotesFocus()" (indBlur)="saveNotes()" [rows]="4" [cols]="10">
                    </ind-text-area>
                }
                <input class="hide-input" #attachInput type="file" (change)="loadImageFromDevice($event)">
            </ion-list>
        }
        @if (features.meetingNotesEnabled) {
            <ion-list [class.off-label-notes-section]="isNewNoteOffLabel">
                <ind-section-header id="{{meetingNotesAndAttachmentsSectionId}}" [viewData]="meetingNotesSectionHeader" (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
                <div [class.off-label-textarea-wrapper]="isNewNoteOffLabel">
                    <ind-text-area id="activity-detail-11" [placeHolder]="notesPlaceholder" [readonly]="activityService.selectedActivity?.isCompleted ||  this.activityService.selectedActivity.state == 2"
                                   [disabled]="backgroundUploadInProgress ? true : isCovisitor && (features.coVisitorAccess === 548910001 || features.coVisitorAccess === 548910002) ? false : isNoteDisabled() || isReadOnlyJointMeeting || activityService.teamViewActive || activityService.selectedActivity?.isDiffPosition" [maxLength]="1000"
                                   [showAttachment]="isMeetingAttachmentAdded" [attachmentTitle]="meetingNoteAttachmentTitle" (removeAttachment)="removeMeetingNoteAttachment($event)" (downloadNotesAttachment)="downloadAttachment($event)"
                                   (indChange)="notesChanged($event)" [value]="tempNoteText" [rows]="4" [cols]="10" (indFocus)="onMeetingNotesFocusIn()" (indBlur)="onMeetingNotesFocusOut()">
                        @if (isOffLabelNotesEnabled && !activityService.selectedActivity?.isCompleted && activityService.selectedActivity.state != 2 && !activityService.teamViewActive && !isNoteDisabled()) {
                            <div class="inline-off-label-toggle">
                                <label class="off-label-switch" [class.is-checked]="isNewNoteOffLabel">
                                    <input type="checkbox" [checked]="isNewNoteOffLabel" (change)="onOffLabelNativeToggle($event)" [disabled]="isNoteDisabled()">
                                    <span class="off-label-switch-track"></span>
                                </label>
                                <span class="off-label-toggle-label">{{'OFF_LABEL_CONTENT' | translate}}</span>
                            </div>
                        }
                    </ind-text-area>
                </div>
                <input class="hide-input" #attachInput type="file" (change)="loadImageFromDevice($event)">
                @for (note of nonDeletedNotes; track trackByNote($index, note)) {
                    <io-note [isNoteAttachmentEnabled]="!backgroundUploadInProgress && features.meetingAttachmentEnabled" [inputNote]="note" [editable]="!backgroundUploadInProgress && isNoteControlsEnabled(note)"
                             [readOnlyNote]="backgroundUploadInProgress || !isNoteControlsEnabled(note)" [readOnlyAttachment]="backgroundUploadInProgress || !features.meetingAttachmentEnabled || device.isOffline"
                             [deletable]="!backgroundUploadInProgress && isNoteControlsEnabled(note)" (saveNoteOut)="updateNote($event)" [disableDownloadInOffline]="true" [from]="uiService.page.ActivitiesDetailsPaneComponent"
                             [isOffLabel]="note.isOffLabel"></io-note>
                }
            </ion-list>
        }
        @if (features.coachingEnabled && !activityService.teamViewActive) {
            <ion-list id="activity-detail-12">
                <ind-section-header id="{{coachingDetailsSectionId}}" [viewData]="{id:'meeting-detail-coaching', title:translate.instant('COACHING')}"></ind-section-header>
                @if (coachingReportService.coachingReports.length == 0) {
                    <ion-list>
                        <ion-item style="height: 88px;">
                        </ion-item>
                    </ion-list>
                }
                @if (coachingReportService.coachingReports) {
                    <ion-list>
                        @for (report of coachingReportService.coachingReports | orderBy:'createdon':false; track trackByCoachingReport($index, report)) {
                            <ion-item (click)="openCoachingReportDetails(report)">
                                <coaching-item [report]="report" [type]="'detailView'"></coaching-item>
                                <ion-icon class="arrow-icon" [ngClass]="{'disabled':enableCoachingView}" style="height:16px; width:16px; color:#007AFF" name="chevron-forward-outline" slot="end"></ion-icon>
                            </ion-item>
                        }
                    </ion-list>
                }
            </ion-list>
        }
        @if (features.meetingObjectivesEnabled) {
            <next-call-objective id="{{callObjectiveSectionId}}" [contacts]="selectedContacts" [isMeetingComplete]="activityService.selectedActivity.isCompleted" [backgroundUploadInProgress]="backgroundUploadInProgress"></next-call-objective>
        }
        @if (isExpenseSectionVisible) {
            <meeting-expenses-section
                [sectionId]="expensesSectionId"
                [meetingId]="activityService.selectedActivity?.ID"
                [isCompleted]="!!activityService.selectedActivity?.isCompleted"
                [isCanceled]="isSelectedMeetingCanceled"
                [meetingStart]="activityService.selectedActivity?.scheduledStart"
                [readOnly]="isExpenseSectionReadOnly"
                [isRequired]="isExpenseSectionRequired"
                [contacts]="expenseContacts"
                [gracePeriodDays]="expenseGracePeriodDays">
            </meeting-expenses-section>
        }
    }
</ion-content>
@if (footerService.shouldShowFooter$ | async) {
    <footer-toolbar #footer [footerView]="'detailView'" [selectedView]="'activities'" (buttonClicked)="onFooterButtonClicked($event)"></footer-toolbar>
}
